<template>
  <div class="scorm-course-detail">
    <iframe id="Iframe" :src="IframeUrl" frameborder="0"></iframe>
    <custom-dialog
      :visible.sync="cDialog.visible"
      @cancel="cDialog.cancel"
      @confirm="cDialog.confirm"
      @close="cDialog.close"
      v-bind="cDialog"
    >
      <div class="txts">{{ cDialog && cDialog.content }}</div>
    </custom-dialog>
  </div>
</template>

<script>
import IframeMessenger from '../../utils/iframePostMessage'
import withRouteTracking from '../../utils/withRouteTracking'
import {questionBrowse, questionUserPopup, isScorm} from '../../api/scorm'
import {getDatabaseCoursesDetail} from '../../api/api'
import {getShareInfo} from '../../utils/wxShare'
import CustomDialog from '@/views/cartoJourney/components/CustomDialog.vue'
const info = {
  components: {
    CustomDialog
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
    IframeUrl() {
      return this.iframeReady ? this.buildIframeUrl() : ''
    }
  },
  data() {
    return {
      IframeDomain: process.env.scormDomain,
      IframeElement: '',
      IframeMessage: null,
      courseId: null,
      courseData: null,
      iframeReady: false,
      cDialog: {
        visible: false,
        showCancelButton: false,
        confirmButtonText: '我知道了',
        content: '该课程已经下架',
        showCloseIcon: false,
        cancel: () => {
          this.cDialog.close()
        },
        confirm: () => {
          this.cDialog.close()
        },
        close: () => {
          this.cDialog.visible = false
          this.$router.back()
        }
      },
    }
  },
  methods: {
    buildIframeUrl() {
      const url = new URL(process.env.scormUrl)
      Object.keys(this.$route.query).forEach(key => {
        const value = this.$route.query[key]
        if (value !== undefined && value !== null) {
          url.searchParams.append(key, String(value))
        }
      })
      return url.toString()
    },
    async getCourseDetail() {
      this.iframeReady = false
      try {
        const res = await getDatabaseCoursesDetail({courseId: this.courseId})
        const detail = res.data || {}
        if (`${detail.state}` === '2') {
          this.handleCourseOffline()
          return
        }
        try {
          const {data: isScormCourse, code} = await isScorm(this.courseId)
          if (code === 0 && !isScormCourse) {
            this.redirectToNormalCourse()
            return
          }
        } catch (e) {
          console.log(e)
        }
        this.courseData = detail
        this.iframeReady = true
        window.sessionStorage.setItem('mainId', this.courseData.id)
        window.sessionStorage.setItem('serviceId', this.courseData.id)
        let entrance = (this.$route.query.entrance) ? this.$route.query.entrance : window.sessionStorage.getItem('entrance')
        window.sessionStorage.setItem('entrance', entrance)
        window.sessionStorage.setItem('traceTitle', '课程详情-' + this.courseData.name)
        let desc = ''
        if (this.courseData.courseLecturers.length > 0) {
          desc = `${this.courseData.courseLecturers[0].name} ${this.courseData.courseLecturers[0].title} ${this.courseData.courseLecturers[0].hospitalName}`
        }
        getShareInfo({
          title: this.courseData.name,
          titleTimeLine: this.courseData.name,
          desc: desc,
          link: window.location.href, // modifyURLParam(window.location.href, 'entrance', '20'),
          linkTimeLine: window.location.href, // modifyURLParam(window.location.href, 'entrance', '21'),
          images: this.courseData && this.courseData.coverMaterial ? this.courseData.coverMaterial.url : '',
        })
        window.sessionStorage.setItem('moduleName', 'scorm课程')
      } catch (e) {
        console.log(e)
      }
    },
    handleCourseOffline() {
      this.iframeReady = false
      this.cDialog.visible = true
    },
    redirectToNormalCourse() {
      this.iframeReady = false
      const query = {...this.$route.query}
      this.$router.replace({
        path: '/courserDetails',
        query
      })
    }
  },
  mounted() {
    this.courseId = this.$route.query.courseId
    this.getCourseDetail()
    this.IframeElement = document.getElementById('Iframe')
    this.IframeMessage = new IframeMessenger({
      domain: this.IframeDomain,
      iframeElement: this.IframeElement,
      routeQuery: this.$route.query,
    })
    this.IframeMessage.init()
    this.IframeMessage.registerOnMessage(({action, data}, send) => {
      // 题目曝光
      if (action === 'scorm.trace.exposure') {
        questionBrowse({
          ...data,
          userId: this.userInfo.id
        })
      }
      // 小节答题
      if (action === 'scorm.trace.answer') {
        questionUserPopup({
          ...data,
          iepUserId: this.userInfo.id,
        })
      }
    })
  },
  beforeDestroy() {
    this.IframeMessage.removeListener()
  },
}

export default withRouteTracking(info)
</script>

<style scoped lang="less">
.scorm-course-detail {
  width: 100%;
  height: 100%;

  iframe {
    width: 100%;
    height: 100%;
    background: transparent;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/course/scormCourseDetail.vue